import {
  useTranslate,
  IResourceComponentsProps,
  useShow,
  useNavigation,
} from "@pankod/refine-core";
import {Show, Typography, Button} from "@pankod/refine-antd";
import { Tag } from "antd";

import { IQuiz } from "interfaces";
import RelatedQuizTags from "./related";

const { Title, Text } = Typography;

const BASE_PATH = (process.env.REACT_APP_BASE_PATH || "/").replace(/\/$/, "");

export const QuizShow: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const { show } = useNavigation();

  const { queryResult } = useShow<IQuiz>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>{t("quiz.fields.languages")}</Title>
      <Text>
        <RelatedQuizTags quiz={record} />
      </Text>

      <Title level={5}>{t("quiz.fields.parent_id")}</Title>
      <Text>
        {record?.parent_id ? (
          <Button type="link" onClick={() => show("quiz", record?.parent_id)}>{record?.parent_id}</Button>
        ) : (
          "-"
        )}
      </Text>

      <Title level={5}>{t("quiz.fields.question")}</Title>
      <Text>{record?.question}</Text>

      <Title level={5}>{t("quiz.fields.answer1")}</Title>
      <Text>{record?.answer1}</Text>

      <Title level={5}>{t("quiz.fields.answer2")}</Title>
      <Text>{record?.answer2}</Text>

      <Title level={5}>{t("quiz.fields.answer3")}</Title>
      <Text>{record?.answer3}</Text>

      <Title level={5}>{t("quiz.fields.answer4")}</Title>
      <Text>{record?.answer4}</Text>

      <Title level={5}>{t("quiz.fields.correctAnswer")}</Title>
      <Text>{record?.correct_answer}</Text>

      <Title level={5}>{t("quiz.fields.quiz_category_name")}</Title>
      <Text>{record?.quiz_category_name}</Text>

      <Title level={5}>{t("quiz.fields.event_name")}</Title>
      <Text>{record?.event_name || "-"}</Text>

      <Title level={5}>{t("quiz.fields.lang")}</Title>
      <Text>{record?.lang}</Text>

      <Title level={5}>{t("quiz.fields.explanation")}</Title>
      {record?.explanation.split('\n').map((item, key) => {
        return <Text>{item}<br/></Text>
      })}

      <Title level={5}>{t("quiz.fields.keywords")}</Title>
      {record?.keywords.map((value) => (
        <a
          key={value}
          href={`${BASE_PATH}/quiz?keywords=${encodeURIComponent(value)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Tag color="blue" style={{ cursor: "pointer" }}>
            {value}
          </Tag>
        </a>
      ))}

      <Title level={5}>{t("quiz.fields.level")}</Title>
      <Text>{record?.level}</Text>

      <Title level={5}>{t("quiz.fields.status")}</Title>
      <Text>{record?.status ? t(`quiz.status.${record.status}`) : ""}</Text>
    </Show>
  );
};
